// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nf-1";
export var messageSideRight = "_nf-2";
export var orderLookupBubbleContainer = "_nf-0";
export var submitButton = "_nf-3";